module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advice-6d1abc37ffc0c9df03364d049224b737.png";